import { Component, Input } from '@angular/core';

@Component({
  selector: 'smartflip-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  imports: [],
})
export class AvatarComponent {
  @Input() imgUrl: string = '';
}
